import axios from "@/services/interceptors";
import axiosGlobal from "axios";
import Vue from "vue";

const state = {
  measurementSites: {},
  measurementSitesLoading: false,
  measurementNetworks: {},
  measurementNetworkIDs: {},
  siteVariables: {},
  thresholdTypesDict: {},
  thresholdTypesList: {},
};

const getters = {
  measurementSitesLoading(state) {
    return state.measurementSitesLoading;
  },
  measurementSites(state, getters) {
    if (state.measurementSites[getters.sinappsAppID]) {
      state.measurementSites[getters.sinappsAppID].sort(function(a, b) {
        var dateB = new Date(b.created_at);
        var dateA = new Date(a.created_at);
        if (dateB < dateA) {
          return -1;
        }
        if (dateB > dateA) {
          return 1;
        }
        return 0;
      });
      return state.measurementSites[getters.sinappsAppID];
    } else {
      return [];
    }
  },
  measurementNetworkIDs(state, getters) {
    return state.measurementNetworkIDs[getters.sinappsAppID];
  },
  measurementNetworks(state, getters) {
    if (state.measurementNetworks[getters.sinappsAppID]) {
      return state.measurementNetworks[getters.sinappsAppID];
    } else {
      return state.measurementNetworkIDs[getters.sinappsAppID].map((el) => {
        oid: el;
      });
    }
  },
  siteVariables(state, getters) {
    return state.siteVariables[getters.sinappsAppID];
  },
  thresholdTypesDict(state) {
    return state.thresholdTypesDict;
  },
  thresholdTypesList(state) {
    return state.thresholdTypesList;
  },
};

const mutations = {
  setMeasurementSitesLoading(state, value) {
    state.measurementSitesLoading = value;
  },
  clearMeasurementSites(state, sinappsAppID) {
    delete state.measurementSites[sinappsAppID];
  },
  setMeasurementNetworkIDs(state, payload) {
    console.log("setMeasurementNetworkIDs called...", payload);
    state.measurementNetworkIDs[payload.sinappsAppID] = payload.data;
  },
  setMeasurementNetworks(state, payload) {
    console.log("setMeasurementNetworks called...", payload);
    state.measurementNetworks[payload.sinappsAppID] = payload.data;
  },
  appendMeasurementSites(state, payload) {
    // console.log("appendMeasurementSites called...", payload);
    const sites = payload.data;
    let existingSites = state.measurementSites[payload.sinappsAppID] || [];
    Vue.set(state.measurementSites, payload.sinappsAppID, [
      ...existingSites,
      ...sites,
    ]);
  },
  appendNetworkSiteVariables(state, payload) {
    let variables = state.siteVariables[payload.sinappsAppID] || [];
    payload.data.forEach((variable) => {
      if (!variables.find((el) => el.oid == variable.oid)) {
        variables.push(variable);
      }
    });
    state.siteVariables[payload.sinappsAppID] = variables;
  },
  setThresholdTypesDict(state, payload) {
    state.thresholdTypesDict = payload;
  },
  setThresholdTypesList(state, payload) {
    state.thresholdTypesList = payload;
  },
};

const actions = {
  getMeasurementNetwork(context, oid) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementnetwork/${oid}/`,
    });
  },
  searchMeasurementSitesOld(context, query) {
    const sinappsAppID = context.getters.sinappsAppID;
    context.commit("clearMeasurementSites", sinappsAppID);
    context.commit("setMeasurementSitesLoading", true);
    context.getters.measurementNetworks.forEach((network) => {
      axios({
        method: "GET",
        data: {},
        url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/?network__oid=${network.oid}&search=${query}`,
      })
        .then((sitesResponse) => {
          context.commit("appendMeasurementSites", {
            data: sitesResponse.data,
            sinappsAppID,
          });
          context.commit("setMeasurementSitesLoading", false);
        })
        .catch((error) => {
          console.log("searchMeasurementSites Error", error, network);
          context.commit("setMeasurementSitesLoading", false);
        });
    });
  },
  searchMeasurementSites(context, query) {
    const sinappsAppID = context.getters.sinappsAppID;
    context.commit("clearMeasurementSites", sinappsAppID);
    context.commit("setMeasurementSitesLoading", true);

    let axiosPromises = [];
    context.getters.measurementNetworkIDs.forEach((oid) => {
      axiosPromises.push(
        context.dispatch("searchMeasurementSitesByNetwork", {
          networkOID: oid,
          query,
        })
      );
    });

    axiosGlobal.all(axiosPromises).then(
      axiosGlobal.spread((...args) => {
        for (let i = 0; i < args.length; i++) {
          context.commit("appendMeasurementSites", {
            data: args[i].data,
            sinappsAppID,
          });
        }
        context.commit("setMeasurementSitesLoading", false);
      })
    );
  },
  getMeasurementSites(context) {
    console.log("getMeasurementSites called...");
    const sinappsAppID = context.getters.sinappsAppID;
    context.commit("clearMeasurementSites", sinappsAppID);
    context.commit("setMeasurementSitesLoading", true);

    let axiosPromises = [];
    context.getters.measurementNetworkIDs.forEach((oid) => {
      axiosPromises.push(context.dispatch("getNetworksMeasurementSites", oid));
    });

    axiosGlobal.all(axiosPromises).then(
      axiosGlobal.spread((...args) => {
        for (let i = 0; i < args.length; i++) {
          context.commit("appendMeasurementSites", {
            data: args[i].data,
            sinappsAppID,
          });
        }
        context.commit("setMeasurementSitesLoading", false);
      })
    );
  },
  fetchNetworkSiteVariables(context, oid) {
    const sinappsAppID = context.getters.sinappsAppID;
    context
      .dispatch("getNetworkSiteVariables", oid)
      .then((response) => {
        context.commit("appendNetworkSiteVariables", {
          data: response.data,
          sinappsAppID,
        });
      })
      .catch((error) => {
        console.log("getNetworkSiteVariables Error", error);
      });
  },
  getNetworksMeasurementSites(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementnetwork/${id}/get_measurement_sites/`,
    });
  },
  searchMeasurementSitesByNetwork(context, { networkOID, query }) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/?network__oid=${networkOID}&search=${query}`,
    });
  },
  getMeasurementSite(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/`,
    });
  },
  deleteMeasurementSite(context, id) {
    return axios({
      method: "DELETE",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/`,
    });
  },
  getSiteSensorsList(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/get_sensors/`,
    });
  },
  getNetworkSiteVariables(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementnetwork/${id}/get_variables/`,
    });
  },
  getSiteVariables(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/get_variables/`,
    });
  },
  saveSiteVariable(context, payload) {
    return axios({
      method: "POST",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/variable/`,
    });
  },
  getSiteSensorStatus(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/get_sensor_status/?qc_level=highest`,
    });
  },
  createMeasurementSite(context, payload) {
    return axios({
      method: "POST",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/`,
    });
  },
  updateMeasurementSite(context, payload) {
    return axios({
      method: "PATCH",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${payload.oid}/`,
    });
  },
  getMeasurementSiteData(
    context,
    { id, from_datetime, to_datetime, qc_level, variable }
  ) {
    return axios({
      method: "GET",
      url:
        `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/get_data/?` +
        _.join(
          _.remove([
            from_datetime ? `from_datetime=${from_datetime}` : "",
            to_datetime ? `to_datetime=${to_datetime}` : "",
            qc_level ? `qc_level=${qc_level}` : "",
            variable ? `variable=${variable}` : "",
          ]),
          "&"
        ),
    });
  },

  getSiteSensorInstallations(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/get_sensor_locations/`,
    });
  },
  getSiteSensorInstallation(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/sensorlocation/${id}/`,
    });
  },
  createSensorInstallation(context, payload) {
    let url = "";
    if (payload.force) {
      url = `${context.getters.meetnetAPIURL}/sensoren/sensorlocation/?close_active=true/`;
    } else {
      url = `${context.getters.meetnetAPIURL}/sensoren/sensorlocation/`;
    }
    delete payload.force;

    return axios({
      method: "POST",
      data: payload,
      url: url,
    });
  },

  editSensorInstallation(context, payload) {
    let url;
    if (payload.force) {
      url = `${context.getters.meetnetAPIURL}/sensoren/sensorlocation/${payload.oid}/?close_active=true/`;
    } else {
      url = `${context.getters.meetnetAPIURL}/sensoren/sensorlocation/${payload.oid}/`;
    }
    delete payload.force;

    return axios({
      method: "PATCH",
      data: payload,
      url: url,
    });
  },

  /*
  Site Thresholds
  */
  getthresholdTypesDict(context) {
    axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/threshold/threshold_types/`,
    })
      .then((response) => {
        console.log("getthresholdTypesDict resp", response.data);
        let thresholdTypesDict = {};
        let thresholdTypesList = [];

        response.data.forEach((el) => {
          Vue.set(thresholdTypesDict, el[0], el[1]);
          thresholdTypesList.push({
            text: el[1],
            value: el[0],
          });
          return el;
        });
        context.commit("setThresholdTypesDict", thresholdTypesDict);
        context.commit("setThresholdTypesList", thresholdTypesList);
      })
      .catch((error) => {
        console.log("getthresholdTypesDict Error", error);
      });
  },
  getSiteThresholds(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/get_thresholds/`,
    });
  },
  createtSiteThreshold(context, payload) {
    return axios({
      method: "POST",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/threshold/`,
    });
  },
  editSiteThreshold(context, payload) {
    return axios({
      method: "PATCH",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/threshold/${payload.oid}/`,
    });
  },
  deletetSiteThreshold(context, oid) {
    return axios({
      method: "DELETE",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/threshold/${oid}/`,
    });
  },

  /*
  Site Validators
  */
  addManualValidation(context, payload) {
    const siteID = payload.siteID;
    console.log("addManualValidation payload", payload);
    return axios({
      method: "POST",
      data: payload.data,
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${siteID}/add_manual_validation/?from_datetime=${payload.from_datetime}&to_datetime=${payload.to_datetime}`,
    });
  },
  getSiteValidators(context, id) {
    return axios({
      method: "GET",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${id}/get_validators/`,
    });
  },
  saveSiteValidator(context, payload) {
    const siteID = payload.siteID;
    delete payload.siteID;
    console.log("saveSiteValidator payload", payload);
    return axios({
      method: "POST",
      data: payload,
      url: `${context.getters.meetnetAPIURL}/sensoren/measurementsite/${siteID}/setupValidators/`,
    });
  },
  deleteSiteValidators(context, oid) {
    return axios({
      method: "DELETE",
      data: {},
      url: `${context.getters.meetnetAPIURL}/sensoren/validator/${oid}/`,
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
